<template>
  <p>
    {{ $t("ResultsIndicatorShowing") }}
    <strong>{{ first }} - {{ last }}</strong> {{ $t("ResultsIndicatorOf") }}
    <strong>{{ total }}</strong> {{ $t("ResultsIndicatorFor") }}
    <strong>{{ term }}</strong>
  </p>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ResultsIndicator",
  props: {
    first: {
      type: Number,
      required: true,
      default: 0
    },
    last: {
      type: Number,
      required: true,
      default: 0
    },
    total: {
      type: Number,
      required: true,
      default: 0
    },
    term: {
      type: String,
      required: true,
      default: ""
    },
  },
});
</script>
